import React from "react";
import { Box, Typography, Container, Button } from "@mui/material";

const YouTubeTitleGenContent = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Container maxWidth="md" sx={{ textAlign: "center", mt: 4 }}>
      {/* Video Section */}
      {/* Introduction */}
      <Typography variant="h4" fontWeight="bold" sx={{ fontSize: "1.75rem" }} gutterBottom>
        Create Click-Worthy YouTube Titles Instantly
      </Typography>
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Get More Views with Optimized Video Titles
      </Typography>
      <Typography variant="body1" paragraph>
        Crafting engaging titles is essential for grabbing attention on YouTube. But coming up with fresh ideas every time? It’s exhausting.
      </Typography>
      <Typography variant="body1" paragraph>
        Our YouTube Title Generator helps you come up with compelling, SEO-friendly titles in seconds—designed to boost clicks and views without the headache.
      </Typography>

      {/* Features */}
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Why Use the YouTube Title Generator?
      </Typography>
      <ul style={{ textAlign: "left", display: "inline-block" }}>
        <li>🧠 AI-Powered Suggestions Based on Your Topic or Keyword</li>
        <li>📈 Optimized for SEO and Higher Click-Through Rates</li>
        <li>⚡ Generate Multiple Titles with One Click</li>
        <li>📋 Instantly Copy Titles or Download a CSV</li>
      </ul>

      {/* How It Works */}
      <Typography variant="h5" fontWeight="bold" gutterBottom mt={4}>
        How to Generate YouTube Titles
      </Typography>
      <ol style={{ textAlign: "left", display: "inline-block" }}>
        <li>Log in to MyFreshTools and open the Title Generator tool.</li>
        <li>Enter your video topic, niche, or main keyword.</li>
        <li>Click “Generate Titles” to get creative, catchy ideas.</li>
        <li>Copy or download the suggestions and start optimizing!</li>
      </ol>

      {/* FAQs */}
      <Typography variant="h5" fontWeight="bold" gutterBottom mt={4}>
        Frequently Asked Questions (FAQs)
      </Typography>
      <Typography variant="body1" fontWeight="bold">✨ What makes these titles better?</Typography>
      <Typography variant="body2" paragraph>
        They’re generated using SEO data and viral content patterns—designed to hook your viewers.
      </Typography>

      <Typography variant="body1" fontWeight="bold">📋 Can I download all titles as a file?</Typography>
      <Typography variant="body2" paragraph>
        Yes! After generation, you'll receive a downloadable CSV with all your title ideas.
      </Typography>

      <Typography variant="body1" fontWeight="bold">💸 Does it cost anything?</Typography>
      <Typography variant="body2" paragraph>
        Free accounts get limited suggestions. Upgrade to unlock unlimited titles and CSV downloads.
      </Typography>

      {/* Call to Action */}
      <Box mt={4}>
        <Button variant="contained" color="success" size="large" onClick={scrollToTop}>
          Start Generating Titles
        </Button>
      </Box>
    </Container>
  );
};

export default YouTubeTitleGenContent;
